import React, { Component } from "react";
import { Spinner, Form, Modal } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import { states } from "../components/States";
import { countries } from "../components/Countries";
import Swal from "sweetalert2";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import coat from "../assets/images/coat.png";
import Sidebar from "../components/Sidebar";
import { withSidebar } from "../context/SidebarContext";

import { translateLicenseStatusCode} from "../Helper/utils";
import moment from "moment";
import { Navbar, Container } from "react-bootstrap";
import axios from "axios";
import { TitleSelect } from "../components/UI";

let LICENCE_FILEBASE64 = "";
let FORM_ID = "";


const baseUrl = process.env.REACT_APP_BASE_URL
 
class LicenseHistory extends Component {
  constructor(props) {
    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
    super(props);
    this.state = {
      data: [],
      renewData: [],
      foodScientistData: [],
      practiceCategory: [],
      feeType: [],
      title: "",
      tertiaryinstitution: "",
      gender: "",
      surname: "",
      prevSurname: "",
      firstname: "",
      othername: "",
      courseStudy: "",
      dob: "",
      orgPosition: "",
      mailingAddres: "",
      phone: "",
      disabled: false,
      nationality: "",
      categoryPractice: "",
      state: "",
      lga: "",
      boxAll: false,
      address: "",
      password: "",
      confirmPassword: "",
      sponsorName: "",
      sponsorName2: "",
      sponsorNo2: "",
      sponsorNo: "",
      orgName: "",
      orgEmail: "",
      orgPhone: "",
      orgAddress: "",
      qualification: "",
      qualificationYear: "",
      // remitaNo: "",
      fileUpload: "",
      city: "",
      email: "",
      nifst: "",
      countryCode: "",
      colorSurname: "black",
      colorFirstName: "black",
      colorTitle: "black",
      colorEmail: "black",
      colorPractice: "black",
      colorOthername: "black",
      colorNationality: "black",
      colorTetiary: "black",
      colorLga: "black",
      colorPhone: "black",
      colorPassword: "black",
      colorPasswordConf: "black",
      colorSponsor: "black",
      colorSponsorNo: "black",
      colorOrgName: "black",
      colorOrgEmail: "black",
      colorOrgPhone: "black",
      colorAddress: "black",
      // colorCity: "black",
      colorPosition: "black",
      colorState: "black",
      colorGender: "black",
      colorDob: "black",
      colorNIFST: "black",
      colorQualYear: "black",
      // colorRemita: "black",
      colorQual: "black",
      colorMailAddress: "black",
      colorCountryCode: "black",
      colorStudy: "black",
      loading: true,
      isLoading: true,
      isUserInfoLoading: true,
      isRenewalLoading: false,
      isUserId: false,
      postsPerPage: 10,
      currentPage: 1,
      fees: "",
      licenseCertificateUrl: "",
      retrievedLicenseInfo: {
        licenseId: null,
        rrr: null,
      },
      // Filter states
      filterStatus: "",
      filterYear: "",
      filterSearch: "",
      // Modal visibility states
      showViewModal: false,
      showRenewModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleQualificationChange = this.handleQualificationChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleFeeChange = this.handleFeeChange.bind(this);
    this.handlePracticeChange = this.handlePracticeChange.bind(this);
  }

  getUserDetails = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/v2/dashboard/user/${localStorage.getItem("userid")}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      const responseJson = await response.json();

      if (response.status === 401) {
        Swal.fire({
          title: "Session Expired",
          text: "Session expired. Please login",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          this.props.history.push("/login");
        });
        return;
      }

      const { licenseInformation } = responseJson;

      this.setState({
        retrievedLicenseInfo: {
          licenseId: licenseInformation.licenseId,
          rrr: licenseInformation.rrr,
        },
        isUserInfoLoading: false,
      });

      // Store these values in localStorage as done in Dashboard.js
      if (licenseInformation.licenseId) {
        localStorage.setItem("licenseId", licenseInformation.licenseId);
        localStorage.setItem("rrr", licenseInformation.rrr);
      }

    } catch (error) {
      console.error("Error fetching user details:", error);
      this.setState({ isUserInfoLoading: false });
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Filter methods
  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  applyFilters = () => {
    this.setState({ currentPage: 1 });
  }

  clearFilters = () => {
    this.setState({
      filterStatus: "",
      filterYear: "",
      filterSearch: "",
      currentPage: 1,
    });
  }

  // Helper to get field value with camelCase fallback to lowercase (for API transition)
  getField = (item, camelCase, lowercase) => item[camelCase] ?? item[lowercase];

  getFilteredData = () => {
    const { data, filterStatus, filterYear, filterSearch } = this.state;

    return data.filter(item => {
      const today = new Date();
      const licenseExpDate = new Date(this.getField(item, 'licenseExpDate', 'licenseexpdate'));
      const isExpired = today > licenseExpDate;
      const daysRemaining = Math.round((licenseExpDate - today) / (1000 * 60 * 60 * 24));

      // Filter by status
      if (filterStatus) {
        if (filterStatus === "expired" && !isExpired) return false;
        if (filterStatus === "expiring" && (isExpired || daysRemaining > 60)) return false;
        if (filterStatus === "active" && (isExpired || daysRemaining <= 60)) return false;
      }

      // Filter by year
      if (filterYear) {
        const licenseYear = new Date(this.getField(item, 'licenseDate', 'licensedate')).getFullYear().toString();
        if (licenseYear !== filterYear) return false;
      }

      // Filter by search (license number)
      if (filterSearch) {
        const searchLower = filterSearch.toLowerCase();
        const licenseNo = (this.getField(item, 'licenseNo', 'licenseno') || this.getField(item, 'formId', 'formid') || "").toLowerCase();
        if (!licenseNo.includes(searchLower)) return false;
      }

      return true;
    });
  }

  // Get unique years from data for filter dropdown
  getAvailableYears = () => {
    const { data } = this.state;
    const years = [...new Set(data.map(item => new Date(this.getField(item, 'licenseDate', 'licensedate')).getFullYear()))];
    return years.sort((a, b) => b - a); // Sort descending
  }

  // Status badge helper
  getStatusBadge = (expiryDate) => {
    const today = new Date();
    const licenseExpDate = new Date(expiryDate);
    const isExpired = today > licenseExpDate;
    const daysRemaining = Math.round((licenseExpDate - today) / (1000 * 60 * 60 * 24));

    if (isExpired) {
      return { className: 'badge bg-danger', text: 'Expired' };
    } else if (daysRemaining <= 60) {
      return { className: 'badge bg-warning text-dark', text: `${daysRemaining} days left` };
    } else {
      return { className: 'badge bg-success', text: 'Active' };
    }
  }

  showTable = () => {
    const { postsPerPage, currentPage } = this.state;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;

    // Get filtered data first
    const filteredData = this.getFilteredData();

    // Sort the data by application date and expiration date in descending order
    const sortedData = [...filteredData].sort((a, b) => {
      // First compare by license date (application date)
      const dateA = new Date(this.getField(a, 'licenseDate', 'licensedate'));
      const dateB = new Date(this.getField(b, 'licenseDate', 'licensedate'));
      if (dateB - dateA !== 0) {
        return dateB - dateA;
      }

      // If license dates are equal, compare by expiration date
      const expA = new Date(this.getField(a, 'licenseExpDate', 'licenseexpdate'));
      const expB = new Date(this.getField(b, 'licenseExpDate', 'licenseexpdate'));
      return expB - expA;
    });

    const currentPosts = sortedData.slice(indexOfFirstPost, indexOfLastPost);


    try {
      return currentPosts.map((item, index) => {
        const licenseExpDate = this.getField(item, 'licenseExpDate', 'licenseexpdate');
        const licenseDate = this.getField(item, 'licenseDate', 'licensedate');
        const recId = this.getField(item, 'recId', 'recid');
        const statusBadge = this.getStatusBadge(licenseExpDate);
        const isFirstItem = postsPerPage * (currentPage - 1) + index + 1 === 1;

        return (
          <tbody key={recId || index}>
            <tr>
              <td>
                <span className="text-xs font-weight-bold">
                  {postsPerPage * (currentPage - 1) + index + 1}
                </span>
              </td>
              <td className="text-xs font-weight-bold">
                {moment(licenseDate).format("LL") === "Invalid date"
                  ? "-"
                  : moment(licenseDate).format("LL")}
              </td>
              <td className="text-xs font-weight-bold">
                {moment(licenseExpDate).format("LL")}
              </td>
              <td>
                <span className={statusBadge.className} style={{ padding: '6px 12px' }}>
                  {statusBadge.text}
                </span>
              </td>
              <td>
                <div className="d-flex gap-1">
                  {/* View Button */}
                  <button
                    className="btn btn-sm btn-outline-primary mb-0"
                    onClick={() => this.handleViewLicense(recId)}
                    title="View Details"
                  >
                    <span className="iconify" data-icon="mdi:eye" style={{ fontSize: '16px' }}>👁</span>
                  </button>

                  {/* Renew Button - only for most recent license */}
                  {isFirstItem && (
                    <button
                      className="btn btn-sm btn-outline-warning mb-0"
                      onClick={() => this.handleRenewLicense(recId)}
                      title="Renew License"
                    >
                      <span className="iconify" data-icon="mdi:refresh" style={{ fontSize: '16px' }}>↻</span>
                    </button>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        );
      });
    } catch (e) {
      Swal.fire({
        title: "Error",
        text: e.message,
        type: "error",
      });
    }
  };

  showPagination = () => {
    const { postsPerPage } = this.state;
    const filteredData = this.getFilteredData();
    const pageNumbers = [];
    const totalPosts = filteredData.length;
    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
      pageNumbers.push(i);
    }

    const paginate = (pageNumbers) => {
      this.setState({ currentPage: pageNumbers });
    };

    return (
      <nav>
        <ul className="pagination">
          {pageNumbers.map((number) => (
            <li
              key={number}
              className={
                this.state.currentPage === number
                  ? "page-item active"
                  : "page-item"
              }
            >
              <button onClick={() => paginate(number)} className="page-link">
                {number}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    );
  };

  handleChange(e) {
    this.setState({ title: e.target.value });
  }
  handleStateChange(e) {
    this.setState({ state: e.target.value });
  }

  handleGenderChange(e) {
    this.setState({ gender: e.target.value });
  }

  handleCountryChange(e) {
    this.setState({ countryCode: e.target.value });
  }

  handleQualificationChange(e) {
    this.setState({ qualification: e.target.value });
  }

  handleCheckChange(e) {
    this.setState({ boxAll: e.target.checked }, () => {
      console.log("This returned true or false", this.state.boxAll);
    });
  }

  handleFeeChange(e) {
    this.setState({ fees: e.target.value });
  }

  handlePracticeChange(e) {
    this.setState({ categoryPractice: e.target.value });
  }

  getFeeType = async () => {
    const url = `${baseUrl}/Fees/getFeesByPaymentType/individual`;
    this.setState({ isLoading: true });
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.warn(res);
        if (res.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/login");
          });
        } else {
          this.setState({ feeType: res });
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
        alert(error);
      });
  };

  getPracticeCategory = async () => {
    const url = `${baseUrl}/Lookups/GetPracticeCategory`;
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/login");
          });
        } else {
          this.setState({ practiceCategory: res });
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
        alert(error);
      });
  };

  showFeeTypes() {
    return this.state.feeType.map((item) => {
      return (
        <option
          disabled={
            item.description === "Membership/Individual Renewal Fee"
              ? ``
              : "disabled"
          }
          value={`${item.paymenttype}, ${item.amount}, ${item.description}, ${item.paymentsubcategory}, ${item.remitaid}`}
        >
          {item.description === "Membership/Individual Renewal Fee"
            ? `${item.description.toUpperCase()} (N${item.amount})`
            : ""}
        </option>
      );
    });
  }

  showPracticeCategory() {
    return this.state.practiceCategory.map((item) => {
      return <option value={item.referencename}>{item.referencename}</option>;
    });
  }

  handleNIFSTCertificateImage = async (e) => {
    const file = e.target.files[0];
    const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

    if (file && file.size > MAX_FILE_SIZE) {
      Swal.fire({
        title: "File Too Large",
        text: "Please upload a file smaller than 1MB",
        icon: "error",
        confirmButtonText: "OK",
      });
      e.target.value = "";
      return;
    }

    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
        LICENCE_FILEBASE64 = fileReader.result;
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  uploadNIFSTCertificate = async () => {
    this.setState({ loading: false });
    var obj = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        imageToBase64String: LICENCE_FILEBASE64,
        formid: FORM_ID,
      }),
    };
    await fetch(`${baseUrl}/Registration/uploadRegistrationImage`, obj)
      .then((response) => response.json())
      .then((responseJson) => {
        // console.warn(responseJson);
        if (responseJson.message === "Image Updated Successfully") {
          // FORM_ID = responseJson.formid;
          this.registerScientist();
        }
      })
      .catch((error) => {
        this.setState({ loading: false, disabled: false });
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  checkValidation = async (e) => {
    const {
      title,
      gender,
      surname,
      firstname,
      othername,
      prevSurname,
      categoryPractice,
      dob,
      address,
      fees,
      tertiaryinstitution,
      qualification,
      qualificationYear,
      courseStudy,
      nationality,
      state,
      nifst,
      phone,
      password,
      confirmPassword,
      mailingAddres,
      sponsorName,
      boxAll,
      sponsorName2,
      sponsorNo,
      sponsorNo2,
      colorPractice,
      lga,
      orgAddress,
      orgPosition,
      orgEmail,
      orgName,
      orgPhone,
      city,
      email,
      countryCode,
      registrationnumber,
      licenseCertificateUrl,
    } = this.state;
    this.setState({ loading: true, disabled: true });
    e.preventDefault();

    if (surname === "" && localStorage.getItem("surname") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please enter your surname",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorSurname: "red" });
    } else if (
      othername === "" &&
      localStorage.getItem("othernames") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your other name",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorOthername: "red" });
    } else if (title === "" && localStorage.getItem("title") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your title",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorTitle: "red" });
    } else if (
      address === "" &&
      localStorage.getItem("contactaddress") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Mailing address",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorMailAddress: "red",
      });
    } else if (dob === "" && localStorage.getItem("DOB") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Date of birth",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorDob: "red" });
    } else if (
      nationality === "" &&
      localStorage.getItem("nationality") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your nationality",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorNationality: "red",
      });
    } else if (gender === "" && localStorage.getItem("gender") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your gender",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorGender: "red" });
    } else if (state === "" && localStorage.getItem("state") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your State of Origin",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorState: "red" });
    } else if (lga === "" && localStorage.getItem("lga") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Local Government Area",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorState: "red" });
    } else if (
      courseStudy === "" &&
      localStorage.getItem("courseofstudy") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your course of study",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorStudy: "red" });
    } else if (
      tertiaryinstitution === "" &&
      localStorage.getItem("tertiaryinstitution") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Tertiary Institution",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorTetiary: "red" });
    } else if (
      nifst === "" &&
      localStorage.getItem("nifstregistrationnumber") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your NIFST number",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorNIFST: "red" });
    } else if (
      qualification === "" &&
      localStorage.getItem("qualification") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Qualification",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorQual: "red" });
    } else if (
      this.state.qualificationYear === "" &&
      localStorage.getItem("yearofqualification") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Year of Qualification",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorQualYear: "red" });
    } else if (
      categoryPractice === "" &&
      localStorage.getItem("practiceCategory") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Practice Category",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorPractice: "red" });
    } else if (countryCode === "" && !localStorage.getItem("token")) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Country Code",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorCountryCode: "red",
      });
    } else if (phone === "" && !localStorage.getItem("token")) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Phone Number",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorPhone: "red" });
    } else if (email === "" && localStorage.getItem("contactemail") === null) {
      Swal.fire({
        title: "Empty",
        text: "Please verify your email",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorEmail: "red" });
    } else if (localStorage.getItem("userid") == "" && password === "") {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Password",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorPassword: "red" });
    } else if (localStorage.getItem("userid") == "" && confirmPassword === "") {
      Swal.fire({
        title: "Empty",
        text: "Please Confirm your Password",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorPasswordConf: "red",
      });
    } else if (
      localStorage.getItem("userid") == "" &&
      confirmPassword !== password
    ) {
      Swal.fire({
        title: "Error",
        text: "Passwords do not match",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorPasswordConf: "red",
        colorPassword: "red",
      });
    } else if (
      mailingAddres === "" &&
      localStorage.getItem("contactaddress") == null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Mailing Address",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorMailAddress: "red",
      });
    } else if (
      orgName === "" &&
      localStorage.getItem("organization") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your Organization Name",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorOrgName: "red" });
    } else if (
      orgPosition === "" &&
      !localStorage.getItem("organizationposition")
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify your position in your Organization",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorPosition: "red" });
    } else if (
      orgAddress === "" &&
      localStorage.getItem("organizationaddress") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify address of your Organization",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({
        loading: false,
        disabled: false,
        colorOrgAddress: "red",
      });
    } else if (
      orgPhone === "" &&
      localStorage.getItem("organizationtelephone") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify phone number of your Organization",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorOrgPhone: "red" });
    } else if (
      orgEmail === "" &&
      localStorage.getItem("organizationemail") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify email of your Organization",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorOrgEmail: "red" });
    } else if (
      sponsorName === "" &&
      localStorage.getItem("sponsorname1").trim().length <= 0
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please supply at least one sponsor",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorSponsor: "red" });
    } else if (
      sponsorNo === "" &&
      localStorage.getItem("sponsorcfsnno1") === null
    ) {
      Swal.fire({
        title: "Empty",
        text: "Please specify the CSFN of Your Sponsor",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false, colorSponsorNo: "red" });
      // } else if (fileUpload === "") {
      //   Swal.fire({
      //     title: "Empty",
      //     text: "Please upload your recent photo",
      //     icon: "error",
      //     confirmButtonText: "OK",
      //   });
      //   this.setState({ loading: false, disabled: false, colorSponsorNo: "red" });
    } else if (boxAll === false) {
      Swal.fire({
        title: "Accept The Terms",
        text: "Please accept the terms and conditions",
        icon: "error",
        confirmButtonText: "OK",
      });
      this.setState({ loading: false, disabled: false });
    } else {
      this.renewLicense();
    }
  };

  // RENEW LICENCE
  renewLicense = async () => {
    let date = new Date();
    let fees = this.state.fees.split(",");

    console.warn(fees);
    localStorage.setItem("amount", fees[1].trim());
    localStorage.setItem("description", fees[2].trim());
    localStorage.setItem("category", fees[3].trim());
    localStorage.setItem("serviceTypeId", fees[4].trim());

    let obj = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },

      body: JSON.stringify({
        DOB:
          this.state.dob !== "" ? this.state.dob : localStorage.getItem("DOB"),
        RRR: "",
        applicationdaterecieved: `${date.getTime()}`,
        contactaddress:
          this.state.address !== ""
            ? this.state.address
            : localStorage.getItem("contactaddress"),
        contactemail:
          this.state.email !== ""
            ? this.state.email
            : localStorage.getItem("contactemail"),
        contacttelephone:
          this.state.phone !== ""
            ? this.state.phone
            : localStorage.getItem("contacttelephone"),
        formtype: "renewal",
        gender:
          this.state.gender !== ""
            ? this.state.gender
            : localStorage.getItem("gender"),
        lga:
          this.state.lga !== "" ? this.state.lga : localStorage.getItem("lga"),
        nationality:
          this.state.nationality !== ""
            ? this.state.nationality
            : localStorage.getItem("nationality"),
        organization:
          this.state.orgName !== ""
            ? this.state.orgName
            : localStorage.getItem("organisation"),
        organizationaddress:
          this.state.orgAddress !== ""
            ? this.state.orgAddress
            : localStorage.getItem("orgAddress"),
        organizationemail:
          this.state.orgEmail !== ""
            ? this.state.orgEmail
            : localStorage.getItem("organizationemail"),
        organizationposition:
          this.state.orgPosition !== ""
            ? this.state.orgPosition
            : localStorage.getItem("organizationposition"),
        organizationtelephone:
          this.state.orgPhone !== ""
            ? this.state.orgPhone
            : localStorage.getItem("organizationtelephone"),
        othernames:
          this.state.ortherName !== ""
            ? this.state.ortherName
            : localStorage.getItem("othernames"),
        practicecategory:
          this.state.categoryPractice !== ""
            ? this.state.categoryPractice
            : localStorage.getItem("practiceCategory"),
        previouslicensedate: "",
        previouslicensenumber: "",
        previoussurname:
          this.state.prevSurname !== ""
            ? this.state.prevSurname
            : localStorage.getItem("previoussurname"),
        qualification1:
          this.state.qualification !== ""
            ? this.state.qualification
            : localStorage.getItem("qualification"),
        qualification2: "",
        qualification3: "",
        qualification4: "",
        qualification5: "",
        recid: localStorage.getItem("recid"),
        registrationnumber:
          this.state.nifst !== ""
            ? this.state.nifst
            : localStorage.getItem("nifstregistrationnumber"),
        state: this.state.state,
        surname:
          this.state.surname !== ""
            ? this.state.surname
            : localStorage.getItem("surname"),
        title: this.state.title,
        yearofqualification:
          this.state.qualificationYear !== ""
            ? this.state.qualificationYear
            : localStorage.getItem("yearofqualification"),
      }),
    };
    fetch(`${baseUrl}/License/updatelicense`, obj)
      .then((response) => response.json())
      .then((responseJson) => {
        console.warn(responseJson);
        if (responseJson.message == "License updated Successfully") {
          this.setState({ loading: false, disabled: false });
          Swal.fire({
            title: "Success",
            text: "License updated Successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/license-renewal-payment");
          });
        } else if (responseJson.status == 401) {
          this.props.history.push("/login");
        }
      })
      .catch((error) => {
        this.setState({ loading: false, disabled: false });
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  getStates() {
    return states.map((state) => {
      return <option value={state}>{state}</option>;
    });
  }

  getCountry() {
    return countries.map((country) => {
      return <option value={country.dial_code}>{country.name}</option>;
    });
  }

  getLicenseRegistration = async () => {
    const url = `${baseUrl}/License/getlicenseByUserID/${localStorage.getItem("userid")}`;
    this.setState({ isLoading: true });
    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.warn(res);
        if (res.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/login");
          });
        } else {
          this.setState({ data: res, loading: false, isLoading: false });
        }
        // console.warn(res);
      })
      .catch((error) => {
        this.setState({ error: true, loading: false, isLoading: false });
        alert(error);
      });
  };

  getLicenseDetails = (recid) => {
    const url = `${baseUrl}/License/getlicenseByRecID/${recid}`;
    this.setState({ isLoading: true });
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        // console.warn(res);
        this.setState({
          isLoading: false,
          foodScientistData: res,
        });
      })
      .catch((error) => {
        this.setState({ error: true, isLoading: false });
        alert(error);
      });
  };

  getUserRenewDetails = (recid) => {
    const url = `${baseUrl}/License/getlicenseByRecID/${recid}`;
    this.setState({ isRenewalLoading: true });
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.warn(res);
        this.setState({
          isRenewalLoading: false,
          renewData: res,
        });
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
        alert(error);
      });
  };

  // Handler that opens View modal
  handleViewLicense = (recid) => {
    this.getLicenseDetails(recid);
    this.setState({ showViewModal: true });
  };

  // Handler that opens Renew modal
  handleRenewLicense = (recid) => {
    this.getUserRenewDetails(recid);
    this.setState({ showRenewModal: true });
  };

  // Close modals
  handleCloseViewModal = () => {
    this.setState({ showViewModal: false });
  };

  handleCloseRenewModal = () => {
    this.setState({ showRenewModal: false });
  };

  async getLicenseCertificate() {
    try {
      const licenseId =this.state.retrievedLicenseInfo?.licenseId;
      if (!licenseId) {
        console.error("License ID is not available in localStorage");
        this.setState({ licenseCertificateUrl: null });
        return;
      }
  
      const response = await axios.get(`${baseUrl}/v2/license/${licenseId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
  
      if (response.data && response.data.licenseCertificate) {
        this.setState({ licenseCertificateUrl: response.data.licenseCertificate });
      } else {
        console.warn("License certificate data is undefined or null");
        this.setState({ licenseCertificateUrl: null });
      }
    } catch (error) {
      console.error("Error fetching license certificate:", error);
      this.setState({ licenseCertificateUrl: null });
    }
  }
  
 async  componentDidMount() {
    const licenseId = localStorage.getItem("licenseId");
    if (!licenseId) {
      console.error("License ID is not available in localStorage");
      return;
    }
    await this.getUserDetails(); // Get user details first to set up sidebar state
    
    await this.getLicenseRegistration();
    await this.getFeeType();
    await this.getPracticeCategory();
    await this.getLicenseCertificate();
  }


  /**
   * Handles downloading the license certificate.
   */
  handleDownload = async (licenseCertificateUrl) => {
    try {
      const response = await fetch(licenseCertificateUrl);
      if (!response.ok) throw new Error("Failed to fetch the certificate.");

      const blob = await response.blob();
      const contentType = response.headers.get("Content-Type");
      let fileExtension = "pdf"; // Default to PDF

      if (contentType) {
        const mimeToExt = {
          "application/pdf": "pdf",
          "image/png": "png",
          "image/jpeg": "jpg",
          "image/jpg": "jpg",
        };
        fileExtension = mimeToExt[contentType] || "bin";
      }

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `license-certificate.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download Error:", error);
      alert("Failed to download the license certificate. Please try again.");
    }
  };


  render() {
    const {
      loading,
      isLoading,
      foodScientistData,
      isRenewalLoading,
      renewData,
      licenseCertificateUrl,
      isUserInfoLoading
    } = this.state;

    if (isUserInfoLoading) {
      return (
        <center>
          <Spinner animation="border" variant="primary" />
        </center>
      );
    }

    return (
      <div className="container" style={{ alignSelf: "center" }}>

    {localStorage.getItem("token") && <Sidebar />}
    <div className="container border-bottom">
      <div className="d-flex justify-content-between">
      <div
        onClick={() => this.props.sidebar.toggle()}
        className="text-center me-2 d-flex align-items-center justify-content-center bg-dark w-15 rounded-full hidden md:flex lg:flex xl:hidden"
        id="dash-menu"
        style={{ height: "50px" }}
      >
        <i className="material-icons text-center opacity-10 text-light w-20">menu</i>
      </div>

       
      </div>
    </div>
    <div
          className="text-center container-fluid px-4 d-flex justify-content-between"
          style={{
            width: "70%",
            justifyContent: "space-evenly",
            alignItems: "center",
            position: "relative",
            top: 63,
            left: 72,
            marginBottom: 27,
          }}
        >
           <div className="text-dark text-bold">
          <h4 style={{ marginTop: 0 }}>License History</h4>
        </div>
          {/* <div>
            <img
              src={logo}
              className="navbar-brand-img"
              alt="main_logo"
              style={{ width: 81 }}
            />
          </div>
          <div style={{ position: "relative", left: 45 }}>
            <h4 className="font-weight-bold text-center">
              NIGERIAN COUNCIL OF FOOD SCIENCE AND TECHNOLOGY (NiCFoST)
            </h4>
          </div>
          <div>
            <img
              src={coat}
              className="navbar-brand-img h-100"
              style={{ width: 126, position: "relative", left: 90 }}
              alt="main_logo"
            />
          </div> */}
        </div>
        <main
          className="main-content position-relative max-height-vh-100 h-100 border-radius-lg "
          style={{ width: "80%", float: "right" }}
        >
          <div
            className="container-fluid justify-content-center py-4"
            style={{ width: "100%", position: "relative", left: 0 }}
          >
            <div className="container-fluid px-4">
              <div className="row">
                <div className="col-12">
                  <div className="card my-3">
                    <div className="card-header pb-0 bg-success">
                      <div className="d-flex flex-wrap align-items-center justify-content-between">
                        <h5 className="mb-4 text-light font-weight-bold">
                          My License Registration History {this.state.data.length > 0 && <span className="badge bg-light text-dark ms-2">{this.state.data.length}</span>}
                        </h5>
                        {licenseCertificateUrl ? (
                          <a href={licenseCertificateUrl} download className="btn btn-light btn-sm">
                            Download License Certificate
                          </a>
                        ) : (
                          <p className="px-3 text-light mb-0">No license certificate available</p>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Filter Section */}
                      <div className="row mb-4 p-3 bg-light rounded">
                        <div className="col-md-3 mb-2">
                          <label className="form-label text-xs font-weight-bold">Status</label>
                          <Form.Select
                            name="filterStatus"
                            value={this.state.filterStatus}
                            onChange={this.handleFilterChange}
                            size="sm"
                          >
                            <option value="">All Statuses</option>
                            <option value="active">Active</option>
                            <option value="expiring">Expiring Soon</option>
                            <option value="expired">Expired</option>
                          </Form.Select>
                        </div>
                        <div className="col-md-3 mb-2">
                          <label className="form-label text-xs font-weight-bold">Year</label>
                          <Form.Select
                            name="filterYear"
                            value={this.state.filterYear}
                            onChange={this.handleFilterChange}
                            size="sm"
                          >
                            <option value="">All Years</option>
                            {this.getAvailableYears().map(year => (
                              <option key={year} value={year}>{year}</option>
                            ))}
                          </Form.Select>
                        </div>
                        <div className="col-md-3 mb-2">
                          <label className="form-label text-xs font-weight-bold">Search</label>
                          <Form.Control
                            type="text"
                            name="filterSearch"
                            placeholder="Search license number..."
                            value={this.state.filterSearch}
                            onChange={this.handleFilterChange}
                            size="sm"
                          />
                        </div>
                        <div className="col-md-3 mb-2 d-flex align-items-end">
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={this.clearFilters}
                          >
                            Clear
                          </button>
                        </div>
                      </div>

                      {loading ? (
                        <center>
                          <Spinner
                            animation="border"
                            variant="success"
                            size="lg"
                            style={{ alignSelf: "center" }}
                            className="text-center"
                          />
                        </center>
                      ) : (
                        <div className="table-responsive p-0 pb-2">
                          <table
                            id="table"
                            className="table align-items-center justify-content-center mb-0"
                          >
                            <thead>
                              <tr>
                                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                  S/N
                                </th>
                                {/* <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Name
                                </th>
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Phone
                                </th>
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Practice Categoryi
                                </th> */}
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Approval date
                                </th>
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Expiration date
                                </th>
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Expiration Status
                                </th>
                                <th className="text-capitalize text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                  Action
                                </th>
                              </tr>
                            </thead>

                            {this.showTable()}
                          </table>
                        </div>
                      )}

                      <div style={{ float: "right" }}>
                        {this.showPagination()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        {/* Start of View Modal */}
        <Modal
          show={this.state.showViewModal}
          onHide={this.handleCloseViewModal}
          size="xl"
          centered
          scrollable
        >
          <Modal.Header
            className="d-flex align-items-center justify-content-between"
            style={{ backgroundColor: "#00264C" }}
          >
            <Modal.Title className="text-light">View Record</Modal.Title>
            <div>
              <button
                type="button"
                className="btn btn-link m-0 p-0 text-light fs-4"
                onClick={() => window.print()}
                aria-label="Print"
              >
                <i
                  style={{ fontSize: 27, color: "#fff" }}
                  className="material-icons opacity-10 text-light"
                >
                  print
                </i>
              </button>
              <button
                type="button"
                className="btn btn-link m-0 p-0 text-light fs-4"
                onClick={this.handleCloseViewModal}
                aria-label="Close"
              >
                <span className="iconify" data-icon="carbon:close">✕</span>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
              {isLoading ? (
                <center>
                  <Spinner
                    animation="border"
                    style={{ padding: 3 }}
                    variant="success"
                    size="lg"
                  />
                </center>
              ) : (
                <div>
                  {foodScientistData.length > 0 &&
                    foodScientistData.map((item) => {
                      return (
                        <main
                          class="main-content position-relative max-height-vh-100 h-100 border-radius-lg "
                          style={{
                            width: !localStorage.getItem("token")
                              ? "90%"
                              : "100%",
                            position: localStorage.getItem("token")
                              ? "relative"
                              : "",
                            right: 0,
                            padding: 18,
                            float: !localStorage.getItem("token")
                              ? ""
                              : "right",
                            marginBottom: 90,
                          }}
                        >
                          <div className="container-fluid px-4">
                            <div className="rown">
                              <div className="col-12">
                                <div className="card my-3 mb-4">
                                  <div className="card-header pb-0 bg-success">
                                    <div className="text-center">
                                      <h5 className="text-light text-center font-weight-bold mb-4">
                                        Application Form for License
                                        Registration
                                      </h5>
                                    </div>
                                  </div>
                                  {/* <div class="card-body"> */}
                                  <div
                                    className="container"
                                    style={{ marginTop: 0, padding: 18 }}
                                  >
                                    <form className="row">
                                      <label
                                        className="mb-3 h4"
                                        style={{ color: "green" }}
                                        htmlFor="floatingInputCustom"
                                      >
                                        Personal Information
                                      </label>
                                      <br />
                                      <br />
                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorSurname,
                                          }}
                                          className="form-label"
                                        >
                                          Surname{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            required="required"
                                            value={item.surname}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label className="form-label text-dark">
                                          Previous Surname (If applicable)
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={item.previoussurname}
                                          />
                                        </div>
                                      </div>

                                      {/*
                  <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                    <label
                      style={{ color: this.state.colorFirstName }}
                      className="form-label"
                    >
                      First name <span className="text-danger">*</span>
                    </label>
                    <div className="input-group input-group-outline mb-3">
                      <label className="form-label"></label>
                      <input
                        className="form-control shadow-none"
                        type="text"
                        required="required"
                        defaultValue={localStorage.getItem("firstname")}
                        onChange={(e) => this.setState({ firstname: e.target.value })}
                      />
                    </div>
                  </div> */}

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorOthername,
                                          }}
                                          className="form-label"
                                        >
                                          Other name(s){" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={item.othernames}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorOthername,
                                          }}
                                          className="form-label"
                                        >
                                          Title{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={item.title}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{ color: this.state.colorDob }}
                                          className="form-label"
                                        >
                                          DOB{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            id="datepicker"
                                            type="date"
                                            value={item.DOB}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          className="form-label"
                                          style={{
                                            color: this.state.colorNationality,
                                          }}
                                        >
                                          Nationality{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            type="text"
                                            className="form-control shadow-none"
                                            value={item.nationality}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          className="form-label"
                                          style={{
                                            color: this.state.colorNationality,
                                          }}
                                        >
                                          Gender{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            type="text"
                                            className="form-control shadow-none"
                                            value={item.gender}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          className="form-label"
                                          style={{
                                            color: this.state.colorNationality,
                                          }}
                                        >
                                          State{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            type="text"
                                            className="form-control shadow-none"
                                            value={item.state}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{ color: this.state.colorLga }}
                                          className="form-label"
                                        >
                                          LGA{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={item.lga}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorNIFST,
                                          }}
                                          className="form-label"
                                        >
                                          CFSN Registration Number{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            onChange={(e) =>
                                              this.setState({
                                                nifst: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <hr />
                                      <div
                                        className="row"
                                        style={{ padding: 20 }}
                                      >
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "green" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          First Qualification
                                        </label>
                                        <br />
                                        <br />

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorQual,
                                            }}
                                            className="form-label"
                                          >
                                            Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={
                                                this.handleQualificationChange
                                              }
                                            >
                                              <option disabled selected>
                                                -- Select qualification --
                                              </option>
                                              <option value="S.S.C.E">
                                                S.S.C.E
                                              </option>
                                              <option value="OND">OND</option>
                                              <option value="HND">HND</option>
                                              <option value="PgD">PgD</option>
                                              <option value="B.Tech">
                                                B.Tech
                                              </option>
                                              <option value="B.SC">B.SC</option>
                                              <option value="M.Tech">
                                                M.Tech
                                              </option>
                                              <option value="M.SC">M.SC</option>
                                              <option value="Ph.D">Ph.D</option>
                                            </select>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorQualYear,
                                            }}
                                            className="form-label"
                                          >
                                            Year of Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              required="required"
                                              onChange={(e) =>
                                                this.setState({
                                                  qualificationYear:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <hr />

                                      <div
                                        className="row"
                                        style={{ padding: 15 }}
                                      >
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "green" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Second Qualification
                                        </label>
                                        <br />
                                        <br />

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label className="form-label">
                                            Second Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={
                                                this.handleQualificationChange2
                                              }
                                            >
                                              <option selected disabled>
                                                -- Select qualification --
                                              </option>
                                              <option value="S.S.C.E">
                                                S.S.C.E
                                              </option>
                                              <option value="OND">OND</option>
                                              <option value="HND">HND</option>
                                              <option value="PgD">PgD</option>
                                              <option value="B.Tech">
                                                B.Tech
                                              </option>
                                              <option value="B.SC">B.SC</option>
                                              <option value="M.Tech">
                                                M.Tech
                                              </option>
                                              <option value="M.SC">M.SC</option>
                                              <option value="Ph.D">Ph.D</option>
                                            </select>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label className="form-label">
                                            Year of Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              required="required"
                                              onChange={(e) =>
                                                this.setState({
                                                  qualificationYear2:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <hr />

                                      <div
                                        className="row"
                                        style={{ padding: 15 }}
                                      >
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "green" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Contact Information
                                        </label>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorPhone,
                                            }}
                                            className="form-label"
                                          >
                                            Phone{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="phone"
                                              required="required"
                                              onChange={(e) =>
                                                this.setState({
                                                  phone: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorEmail,
                                            }}
                                            className="form-label"
                                          >
                                            Email{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="email"
                                              required="required"
                                              onChange={(e) =>
                                                this.setState({
                                                  email: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        {localStorage.getItem(
                                          "userid"
                                        ) ? null : (
                                          <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                            <label
                                              style={{
                                                color: this.state.colorPassword,
                                              }}
                                              className="form-label"
                                            >
                                              Password{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <input
                                                className="form-control shadow-none"
                                                type="text"
                                                required="required"
                                                onChange={(e) =>
                                                  this.setState({
                                                    password: e.target.value,
                                                  })
                                                }
                                                defaultValue={localStorage.getItem(
                                                  "password"
                                                )}
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {localStorage.getItem(
                                          "userid"
                                        ) ? null : (
                                          <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                            <label
                                              style={{
                                                color:
                                                  this.state.colorPasswordConf,
                                              }}
                                              className="form-label"
                                            >
                                              Confirm Pasword{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <input
                                                className="form-control shadow-none"
                                                type="text"
                                                required="required"
                                                onChange={(e) =>
                                                  this.setState({
                                                    confirmPassword:
                                                      e.target.value,
                                                  })
                                                }
                                                defaultValue={localStorage.getItem(
                                                  "confirmPassword"
                                                )}
                                              />
                                            </div>
                                          </div>
                                        )}

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color:
                                                this.state.colorMailAddress,
                                            }}
                                            className="form-label"
                                          >
                                            Mailing Address{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>

                                            <textarea
                                              className="form-control shadow-none"
                                              type="text"
                                              required="required"
                                              onChange={(e) =>
                                                this.setState({
                                                  mailingAddres: e.target.value,
                                                })
                                              }
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>

                                      <hr />
                                      <label
                                        className="mb-3 h4"
                                        style={{ color: "green" }}
                                        htmlFor="floatingInputCustom"
                                      >
                                        Place of work
                                      </label>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorOrgName,
                                          }}
                                          className="form-label"
                                        >
                                          Name of Organization/Institution{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            required="required"
                                            defaultValue={item.organization || item.organisationname}
                                            onChange={(e) =>
                                              this.setState({
                                                orgName: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorPosition,
                                          }}
                                          className="form-label"
                                        >
                                          Position{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            defaultValue={
                                              item.organizationposition
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                position: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorAddress,
                                          }}
                                          className="form-label"
                                        >
                                          Address{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                address: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorOrgPhone,
                                          }}
                                          className="form-label"
                                        >
                                          Organization Telephone{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                orgPhone: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorOrgEmail,
                                          }}
                                          className="form-label"
                                        >
                                          Organization Email{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                orgEmail: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <hr />

                                      <label
                                        className="h4"
                                        htmlFor="floatingInputCustom"
                                        style={{ color: "green" }}
                                      >
                                        Practice Categoryd
                                      </label>
                                      <br />
                                      <br />

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorPraCat,
                                          }}
                                          className="form-label"
                                        >
                                          Practice Categorfy{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <select
                                            className="form-control shadow-none"
                                            aria-label="Select"
                                            onChange={this.handlePracticeChange}
                                            style={{
                                              color: this.state.colorPraCat,
                                            }}
                                          >
                                            <option selected disabled>
                                              -- Select category --
                                            </option>
                                            {this.showPracticeCategory()}
                                          </select>
                                        </div>
                                      </div>

                                      <hr />

                                      <label
                                        className="h4"
                                        htmlFor="floatingInputCustom"
                                        style={{ color: "green" }}
                                      >
                                        Current License
                                      </label>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorCurLic,
                                          }}
                                          className="form-label"
                                        >
                                          License Number{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            onChange={(e) =>
                                              this.setState({
                                                curLicense: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorCurLicDate,
                                          }}
                                          className="form-label"
                                        >
                                          Date{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="date"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                curLicenseDate: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <hr />

                                      <label
                                        className="h4"
                                        htmlFor="floatingInputCustom"
                                        style={{ color: "green" }}
                                      >
                                        Previous License
                                      </label>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorPrevLic,
                                          }}
                                          className="form-label"
                                        >
                                          License Number{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            onChange={(e) =>
                                              this.setState({
                                                prevLicense: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorPrevLicDate,
                                          }}
                                          className="form-label"
                                        >
                                          Date{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="date"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                prevLicenseDate: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label
                                          style={{
                                            color: this.state.colorPrevLicDate,
                                          }}
                                          className="form-label"
                                        >
                                          Expiry Date{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="date"
                                            required="required"
                                            onChange={(e) =>
                                              this.setState({
                                                expDate: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>

                                      <hr />

                                      <label
                                        className="h4"
                                        htmlFor="floatingInputCustom"
                                        style={{ color: "#145973" }}
                                      >
                                        Official
                                      </label>
                                      <br />
                                      <br />

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label className="form-label">
                                          Application Status
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className={
                                              (item.applicationStatus || item.applicationstatus) ===
                                              "approved"
                                                ? "form-control shadow-none bg-success text-center text-uppercase font-weight-bold text-light"
                                                : (item.applicationStatus || item.applicationstatus) ===
                                                  "pending"
                                                ? "form-control text-center text-uppercase font-weight-bold text-light shadow-none bg-warning"
                                                : (item.applicationStatus || item.applicationstatus) ===
                                                  "rejected"
                                                ? "form-control text-center text-uppercase font-weight-bold text-light shadow-none bg-danger"
                                                : "form-control shadow-none"
                                            }
                                            type="text"
                                            value={item.applicationStatus || item.applicationstatus}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label className="form-label">
                                          License Date
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={`${item.licenseDate || item.licensedate}`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label className="form-label">
                                          License Number
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={`${item.licenseNumber || item.licensenumber}`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                        <label className="form-label">
                                          License Remarks
                                        </label>
                                        <div className="input-group input-group-outline mb-3">
                                          <label className="form-label"></label>
                                          <input
                                            className="form-control shadow-none"
                                            type="text"
                                            value={`${item.licenseRemarks || item.licenseremarks}`}
                                          />
                                        </div>
                                      </div>

                                      <div style={{ height: 45 }} />

                                      <label
                                        className="h5"
                                        htmlFor="floatingInputCustom"
                                      >
                                        Certificates
                                      </label>

                                      <div
                                        style={{
                                          flexDirection: "row",
                                          alignItems: "center",
                                          margin: 9,
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {(item.qualificationImage1 || item.qualificationimage1) ? (
                                          <img
                                            crossOrigin="anonymous"
                                            width="306"
                                            height="306"
                                            src={`${item.qualificationImage1 || item.qualificationimage1}`}
                                          />
                                        ) : (
                                          <img
                                            src="../assets/images/image.jpeg"
                                            alt="No image uploaded for qualification 1"
                                          />
                                        )}

                                        {(item.qualificationImage2 || item.qualificationimage2) ? (
                                          <img
                                            crossOrigin="anonymous"
                                            width="306"
                                            height="306"
                                            src={`${item.qualificationImage2 || item.qualificationimage2}`}
                                          />
                                        ) : (
                                          <img
                                            src="../assets/images/image.jpeg"
                                            alt="No image uploaded for qualification 2"
                                          />
                                        )}

                                        {(item.qualificationImage3 || item.qualificationimage3) ? (
                                          <img
                                              alt={``}
                                            crossOrigin="anonymous"
                                            width="306"
                                            height="306"
                                            src={`${item.qualificationImage3 || item.qualificationimage3}`}
                                          />
                                        ) : (
                                          <img
                                            src="../assets/images/image.jpeg"
                                            alt="No image uploaded for qualification 3"
                                          />
                                        )}

                                        {(item.qualificationImage4 || item.qualificationimage4) ? (
                                          <img
                                            crossOrigin="anonymous"
                                            width="306"
                                            height="306"
                                            src={`${item.qualificationImage4 || item.qualificationimage4}`}
                                          />
                                        ) : (
                                          <img
                                            src="../assets/images/image.jpeg"
                                            alt="No image uploaded for qualification 4"
                                          />
                                        )}

                                        {(item.qualificationImage5 || item.qualificationimage5) ? (
                                          <img
                                            crossOrigin="anonymous"
                                            width="306"
                                            height="306"
                                            src={`${item.qualificationImage5 || item.qualificationimage5}`}
                                          />
                                        ) : (
                                          <img
                                            src="../assets/images/image.jpeg"
                                            alt="No image uploaded for qualification 5"
                                          />
                                        )}
                                      </div>

                                      {/*  <div className="row" style={{ marginTop: 25 }}>
                            <Form.Floating className="mb-3">
                              <input
                                class="form-check-input shadow-none"
                                type="checkbox"
                                id="checkBoxUS"
                                name="US"
                                value="US"
                                onChange={this.handleCheckChange}
                              />{" "}
                              I hereby certify that I am not a registered and practicing
                              member of an allied profession and the particulars furnished
                              herein are true
                            </Form.Floating>
                          </div>

                          <div
                          className="text-center"
                            style={{
                              margin: "auto",
                              width: "100%",
                              marginTop: 45,
                              marginBottom: "15vh",
                            }}
                          >
                            <button
                              disabled={this.state.disabled}
                              style={{
                                alignSelf: "center",
                                width: "100%",
                                backgroundColor: "#003314",
                              }}
                              className="btn btn-success btn-lg"
                              onClick={(e) => this.checkValidation(e)}
                            >
                              {loading ? (
                                <Spinner animation="border" variant="light" size="sm" />
                              ) : (
                                <span className="font-weight-bold">
                                  {/* APPLY <i class="fas fa-chevron-right"></i> */}
                                      {/*  SUBMIT APPLICATION
                                </span>
                              )}
                            </button>
                          </div> */}
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*   </div>*/}
                        </main>
                      );
                    })}
                </div>
              )}
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-danger"
              onClick={this.handleCloseViewModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        {/* End of View Modal */}

        {/* Start of Renewal Modal */}
        <Modal
          show={this.state.showRenewModal}
          onHide={this.handleCloseRenewModal}
          size="xl"
          centered
          scrollable
        >
          <Modal.Header
            className="d-flex align-items-center justify-content-between"
            style={{ backgroundColor: "#00264C" }}
          >
            <Modal.Title className="text-light font-weight-bold">
              Renew License
            </Modal.Title>
            <button
              type="button"
              className="btn btn-link m-0 p-0 text-light fs-4"
              onClick={this.handleCloseRenewModal}
              aria-label="Close"
            >
              <span className="iconify" data-icon="carbon:close">✕</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            {isRenewalLoading ? (
              <center>
                <Spinner
                  animation="border"
                  style={{ padding: 9 }}
                  variant="success"
                  size="lg"
                />
              </center>
            ) : (
              <div>
                  <div className="container-fluid px-4">
                    {renewData.length > 0 &&
                      renewData.map((item) => {
                        localStorage.setItem("DOB", `${item.dob || item.DOB}`);
                        localStorage.setItem("formid", `${item.formId || item.formid}`);
                        localStorage.setItem("surname", `${item.surname}`);
                        localStorage.setItem(
                          "previoussurname",
                          `${item.previousSurname || item.previoussurname}`
                        );
                        localStorage.setItem("firstName", `${item.surname}`);
                        localStorage.setItem(
                          "othernames",
                          `${item.otherNames || item.othernames}`
                        );
                        localStorage.setItem("title", `${item.title}`);
                        localStorage.setItem(
                          "nationality",
                          `${item.nationality}`
                        );
                        localStorage.setItem("gender", `${item.gender}`);
                        localStorage.setItem("state", `${item.state}`);
                        localStorage.setItem("lga", `${item.lga}`);
                        localStorage.setItem(
                          "nifstregistrationnumber",
                          `${item.nifstRegistrationNumber || item.nifstregistrationnumber}`
                        );
                        localStorage.setItem(
                          "courseofstudy",
                          `${item.courseOfStudy || item.courseofstudy}`
                        );
                        localStorage.setItem(
                          "tertiaryinstitution",
                          `${item.tertiaryInstitution || item.tertiaryinstitution}`
                        );
                        localStorage.setItem(
                          "qualification",
                          `${item.qualification}`
                        );
                        localStorage.setItem(
                          "yearofqualification",
                          `${item.yearOfQualification || item.yearofqualification}`
                        );
                        localStorage.setItem(
                          "contactaddress",
                          `${item.contactAddress || item.contactaddress}`
                        );
                        localStorage.setItem(
                          "contactemail",
                          `${item.contactEmail || item.contactemail}`
                        );
                        localStorage.setItem(
                          "practicecategory",
                          `${item.practiceCategory || item.practicecategory}`
                        );
                        localStorage.setItem(
                          "organization",
                          `${item.organization}`
                        );
                        localStorage.setItem(
                          "organizationposition",
                          `${item.organizationPosition || item.organizationposition}`
                        );
                        localStorage.setItem(
                          "organizationaddress",
                          `${item.organizationAddress || item.organizationaddress}`
                        );
                        localStorage.setItem(
                          "organizationtelephone",
                          `${item.organizationTelephone || item.organizationtelephone}`
                        );
                        localStorage.setItem(
                          "organizationemail",
                          `${item.organizationEmail || item.organizationemail}`
                        );
                        localStorage.setItem(
                          "sponsorname1",
                          `${item.sponsorName1 || item.sponsorname1}`
                        );
                        localStorage.setItem(
                          "sponsorcfsnno1",
                          `${item.sponsorCfsnNo1 || item.sponsorcfsnno1}`
                        );
                        localStorage.setItem(
                          "sponsorcfsnno2",
                          `${item.sponsorCfsnNo2 || item.sponsorcfsnno2}`
                        );
                        localStorage.setItem(
                          "sponsorname2",
                          `${item.sponsorName2 || item.sponsorname2}`
                        );
                        localStorage.setItem("recid", `${item.recId || item.recid}`);

                        return (
                          <main
                            class="main-content position-relative max-height-vh-100 h-100 border-radius-lg "
                            style={{
                              width: !localStorage.getItem("token")
                                ? "90%"
                                : "100%",
                              position: localStorage.getItem("token")
                                ? "relative"
                                : "",
                              right: 0,
                              padding: 18,
                              float: !localStorage.getItem("token")
                                ? ""
                                : "right",
                              marginBottom: 90,
                            }}
                          >
                            <div className="container-fluid px-4">
                              <div className="rown">
                                <div className="col-12">
                                  <div className="card my-3 mb-4">
                                    <div className="card-header pb-0 bg-success">
                                      <div className="text-center">
                                        <h5 className="text-light text-center font-weight-bold mb-4">
                                          Renewal Form for License
                                        </h5>
                                      </div>
                                    </div>
                                    {/* <div class="card-body"> */}

                                    <div
                                      className="container"
                                      style={{ marginTop: 18, padding: 9 }}
                                    >
                                      <div style={{ marginTop: 0 }}></div>
                                      <form className="row">
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "#145973" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Personal Information
                                        </label>
                                        <br />
                                        <br />
                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorSurname,
                                            }}
                                            className="form-label"
                                          >
                                            Surname{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control w-50 shadow-none"
                                              type="text"
                                              required="required"
                                              defaultValue={item.surname}
                                              onChange={(e) =>
                                                this.setState({
                                                  surname: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label className="form-label text-dark">
                                            Previous Surname
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control w-50 shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.previoussurname
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  prevSurname: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorOthername,
                                            }}
                                            className="form-label"
                                          >
                                            Other name(s){" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.othernames}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorTitle,
                                            }}
                                            className="form-label"
                                          >
                                            Title{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <TitleSelect
                                              value={this.state.title || item.title}
                                              onChange={this.handleChange}
                                              style={{
                                                color: this.state.colorTitle,
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorDob,
                                            }}
                                            className="form-label"
                                          >
                                            DOB{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.DOB}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            className="form-label"
                                            style={{
                                              color:
                                                this.state.colorNationality,
                                            }}
                                          >
                                            Nationality{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              type="text"
                                              className="form-control shadow-none"
                                              defaultValue={item.nationality}
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            className="form-label"
                                            style={{
                                              color: this.state.colorGender,
                                            }}
                                          >
                                            Select Gender{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={this.handleGenderChange}
                                              style={{
                                                color: this.state.colorGender,
                                              }}
                                            >
                                              <option
                                                value={
                                                  item.gender
                                                    ? item.gender
                                                    : "-- Select gender--"
                                                }
                                                selected
                                              >
                                                {item.gender
                                                  ? item.gender
                                                  : "-- Select gender --"}
                                              </option>
                                              <option value="male">Male</option>
                                              <option value="female">
                                                Female
                                              </option>
                                            </select>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorState,
                                            }}
                                            className="form-label"
                                          >
                                            Select State{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select state"
                                              onChange={this.handleStateChange}
                                              style={{
                                                color: this.state.colorState,
                                              }}
                                            >
                                              <option
                                                value={
                                                  item.state
                                                    ? item.state
                                                    : "-- Select state --"
                                                }
                                                selected
                                              >
                                                {item.state
                                                  ? item.state
                                                  : "-- Select state --"}
                                              </option>
                                              {this.getStates()}
                                            </select>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorLga,
                                            }}
                                            className="form-label"
                                          >
                                            LGA{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              required="required"
                                              defaultValue={item.lga}
                                              onChange={(e) =>
                                                this.setState({
                                                  lga: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorNIFST,
                                            }}
                                            className="form-label"
                                          >
                                            NIFST Registration Number{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.nifstregistrationnumber
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  nifst: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <hr />
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "#145973" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Qualification
                                        </label>
                                        <br />
                                        <br />

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorStudy,
                                            }}
                                            className="form-label"
                                          >
                                            Course of study
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.courseofstudy}
                                              onChange={(e) =>
                                                this.setState({
                                                  courseStudy: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorTetiary,
                                            }}
                                            className="form-label"
                                          >
                                            Tertiary Institution
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.tertiaryinstitution
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  tertiaryinstitution:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorQual,
                                            }}
                                            className="form-label"
                                          >
                                            Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={
                                                this.handleQualificationChange
                                              }
                                              style={{
                                                color: this.state.colorQual,
                                              }}
                                            >
                                              <option
                                                value={
                                                  item.qualification
                                                    ? item.qualification
                                                    : "-- Select qualification --"
                                                }
                                                selected
                                              >
                                                {item.qualification
                                                  ? item.qualification
                                                  : "-- Select qualification --"}
                                              </option>
                                              <option value="S.S.C.E">
                                                S.S.C.E
                                              </option>
                                              <option value="OND">OND</option>
                                              <option value="HND">HND</option>
                                              <option value="PgD">PgD</option>
                                              <option value="B.Tech">
                                                B.Tech
                                              </option>
                                              <option value="B.SC">B.SC</option>
                                              <option value="M.Tech">
                                                M.Tech
                                              </option>
                                              <option value="M.SC">M.SC</option>
                                              <option value="Ph.D">Ph.D</option>
                                            </select>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorQualYear,
                                            }}
                                            className="form-label"
                                          >
                                            Year of Qualification{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.yearofqualification
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  qualificationYear:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <hr />

                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "#145973" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Contact Information
                                        </label>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color:
                                                this.state.colorMailAddress,
                                            }}
                                            className="form-label"
                                          >
                                            Mailing Address{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>

                                            <textarea
                                              className="form-control shadow-none"
                                              type="text"
                                              required="required"
                                              rows="1"
                                              defaultValue={item.contactAddress || item.contactaddress}
                                              onChange={(e) =>
                                                this.setState({
                                                  mailingAddres: e.target.value,
                                                })
                                              }
                                            ></textarea>
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            className="form-label"
                                            style={{
                                              color: this.state.colorEmail,
                                            }}
                                          >
                                            Email{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="email"
                                              defaultValue={item.contactEmail || item.contactemail}
                                              onChange={(e) =>
                                                this.setState({
                                                  email: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            className="form-label"
                                            style={{
                                              color:
                                                this.state.practicecategory,
                                            }}
                                          >
                                            Practice Categoryw{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={
                                                this.handlePracticeChange
                                              }
                                              style={{
                                                color: this.state.colorPractice,
                                              }}
                                            >
                                              <option
                                                value={
                                                  item.practiceCategory
                                                    ? item.practiceCategory
                                                    : "-- Select practice category --"
                                                }
                                                selected
                                              >
                                                {item.practiceCategory
                                                  ? item.practiceCategory
                                                  : "-- Select practice category --"}
                                              </option>
                                              {this.showPracticeCategory()}
                                            </select>
                                          </div>
                                        </div>

                                        <hr />
                                        <label
                                          className="mb-3 h4"
                                          style={{ color: "#145973" }}
                                          htmlFor="floatingInputCustom"
                                        >
                                          Place of work
                                        </label>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorOrgName,
                                            }}
                                            className="form-label"
                                          >
                                            Name of Organization/Institution{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              defaultValue={item.organization}
                                              onChange={(e) =>
                                                this.setState({
                                                  orgName: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorPosition,
                                            }}
                                            className="form-label"
                                          >
                                            Position{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.organizationposition
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  orgPosition: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorOrgAddress,
                                            }}
                                            className="form-label"
                                          >
                                            Address{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.organizationaddress
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  orgAddress: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorOrgPhone,
                                            }}
                                            className="form-label"
                                          >
                                            Organization Telephone{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.organizationtelephone
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  orgPhone: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorOrgEmail,
                                            }}
                                            className="form-label"
                                          >
                                            Organization Email{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={
                                                item.organizationemail
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  orgEmail: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <hr />

                                        <label
                                          className="h4"
                                          htmlFor="floatingInputCustom"
                                          style={{ color: "#145973" }}
                                        >
                                          Sponsor Information
                                        </label>
                                        <br />
                                        <br />

                                        <label
                                          className="h5"
                                          htmlFor="floatingInputCustom"
                                        >
                                          Sponsor 1
                                        </label>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorSponsor,
                                            }}
                                            className="form-label"
                                          >
                                            Sponsor Name{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.sponsorname1}
                                              onChange={(e) =>
                                                this.setState({
                                                  sponsorName: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorSponsorNo,
                                            }}
                                            className="form-label"
                                          >
                                            Current CFSN Number{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.sponsorcfsnno1}
                                              onChange={(e) =>
                                                this.setState({
                                                  sponsorNo: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <label
                                          className="h5"
                                          htmlFor="floatingInputCustom"
                                        >
                                          Sponsor 2
                                        </label>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label className="form-label">
                                            Sponsor Name
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.sponsorname2}
                                              onChange={(e) =>
                                                this.setState({
                                                  sponsorName2: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label className="form-label">
                                            Current CFSN Number
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <input
                                              className="form-control shadow-none"
                                              type="text"
                                              defaultValue={item.sponsorcfsnno2}
                                              onChange={(e) =>
                                                this.setState({
                                                  sponsorNo2: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <hr />

                                        <label
                                          className="h5"
                                          htmlFor="floatingInputCustom"
                                        >
                                          Payments
                                        </label>

                                        <div className="col-sm-6 col-lg-6 col-md-6 mb-3">
                                          <label
                                            style={{ color: "black" }}
                                            className="form-label"
                                          >
                                            Select Payment{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="input-group input-group-outline mb-3">
                                            <label className="form-label"></label>
                                            <select
                                              className="form-control shadow-none"
                                              aria-label="Select"
                                              onChange={this.handleFeeChange}
                                              style={{
                                                color: this.state.colorCompany,
                                              }}
                                            >
                                              <option selected="selected">
                                                -- Select payment type --
                                              </option>
                                              {this.showFeeTypes()}
                                            </select>
                                          </div>
                                        </div>
                                        <hr />

                                        <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                          <label
                                            style={{
                                              color: this.state.colorNIFSTImage,
                                            }}
                                            htmlFor="floatingInputCustom"
                                          >
                                            Upload Your NIFST Certificate Image
                                          </label>{" "}
                                          <span className="text-danger">*</span>
                                          <div className="col-sm-6 col-lg-12 col-md-6 mb-3">
                                            <input
                                              className="form-control shadow-none"
                                              type="file"
                                              required="required"
                                              onChange={
                                                this.handleNIFSTCertificateImage
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div style={{ height: 45 }} />

                                        {/*Create Login details */}

                                        {!localStorage.getItem("userid") && (
                                          <label
                                            className="h4"
                                            htmlFor="floatingInputCustom"
                                            style={{ color: "#145973" }}
                                          >
                                            Create Login Details <br />
                                            <span
                                              className="text-danger"
                                              style={{ fontSize: 18 }}
                                            >
                                              Use this account to login to your
                                              dashboard for tracking, renewal
                                              and subsequent applications.
                                            </span>
                                            <br />
                                            <br />
                                          </label>
                                        )}
                                        {!localStorage.getItem("userid") && (
                                          <br />
                                        )}
                                        {!localStorage.getItem("userid") && (
                                          <br />
                                        )}

                                        {!localStorage.getItem("userid") && (
                                          <div
                                            className="col-sm-6 col-lg-4 col-md-6 mb-3"
                                            style={{ display: "none" }}
                                          >
                                            <label
                                              style={{
                                                color:
                                                  this.state.colorCountryCode,
                                              }}
                                              className="form-label"
                                            >
                                              Country{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <select
                                                className="form-control shadow-none"
                                                aria-label="Floating label select example"
                                                onChange={
                                                  this.handleCountryChange
                                                }
                                              >
                                                <option
                                                  value="choose"
                                                  selected="selected"
                                                >
                                                  -- Select country code --
                                                </option>
                                                {this.getCountry()}
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {!localStorage.getItem("userid") && (
                                          <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                            <label
                                              style={{
                                                color: this.state.colorPhone,
                                              }}
                                              className="form-label"
                                            >
                                              Phone{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <input
                                                className="form-control shadow-none"
                                                type="phone"
                                                required="required"
                                                onChange={(e) =>
                                                  this.setState({
                                                    phone: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {!localStorage.getItem("userid") && (
                                          <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                            <label
                                              style={{
                                                color: this.state.colorPassword,
                                              }}
                                              className="form-label"
                                            >
                                              Pasword{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <input
                                                className="form-control shadow-none"
                                                type="text"
                                                required="required"
                                                onChange={(e) =>
                                                  this.setState({
                                                    password: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {!localStorage.getItem("userid") && (
                                          <div className="col-sm-6 col-lg-4 col-md-6 mb-3">
                                            <label
                                              style={{
                                                color:
                                                  this.state.colorPasswordConf,
                                              }}
                                              className="form-label"
                                            >
                                              Confirm Pasword{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group input-group-outline mb-3">
                                              <label className="form-label"></label>
                                              <input
                                                className="form-control shadow-none"
                                                type="text"
                                                required="required"
                                                onChange={(e) =>
                                                  this.setState({
                                                    confirmPassword:
                                                      e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                        )}

                                        <div
                                          className="row"
                                          style={{ marginTop: 25 }}
                                        >
                                          <Form.Floating className="mb-3">
                                            <input
                                              class="form-check-input shadow-none"
                                              type="checkbox"
                                              id="checkBoxUS"
                                              name="US"
                                              value="US"
                                              onChange={this.handleCheckChange}
                                            />{" "}
                                            I hereby certify that I am not a
                                            registered and practicing member of
                                            an allied profession and the
                                            particulars furnished herein are
                                            true
                                          </Form.Floating>
                                          <h6>
                                            TAKE NOTICE: THE NICFOST SHALL MAKE
                                            A CLAIM AND RECOVER ALL COSTS OF
                                            LITIGATION INCURRED BY IN IN DEFENCE
                                            OF ANY COURT ACTION INSTITUTED
                                            AGAINST IT AT THE INSTANCE OF ANY
                                            CERTIFIED FOOD SCIENTIST AND/OR
                                            LICENSED FOOD SCIENTIST PREMISES AND
                                            WHEREBY THE SUIT IS STRUCK OUT,
                                            WITHDRAWN OR THE FOOD SCIENTIST OR
                                            THE FOOD SCIENTIST PREMISES LOSES
                                            THE CASE.
                                          </h6>
                                        </div>

                                        <div
                                          className="text-center"
                                          style={{
                                            margin: "auto",
                                            width: "100%",
                                            marginTop: 45,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <button
                                            disabled={this.state.disabled}
                                            style={{
                                              alignSelf: "center",
                                              width: "60%",
                                              backgroundColor: "#147332",
                                            }}
                                            className="btn btn-success btn-lg"
                                            onClick={(e) =>
                                              this.checkValidation(e)
                                            }
                                          >
                                            {loading ? (
                                              <Spinner
                                                animation="border"
                                                variant="light"
                                                size="sm"
                                              />
                                            ) : (
                                              <span className="font-weight-bold">
                                                {/* APPLY <i class="fas fa-chevron-right"></i> */}
                                                SUBMIT APPLICATION
                                              </span>
                                            )}
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </main>
                        );
                      })}
                  </div>
                </div>
              )}
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-danger"
              onClick={this.handleCloseRenewModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        {/* End of Renewal Modal */}
      </div>
    );
  }
}

export default withSidebar(LicenseHistory);
